import { PageFrame } from "../../components/page_frame";
import { ThreeForecastTrackingContainer } from "./container";

export default function ThreeForecastTrackingPage() {
  return (
    <PageFrame>
      <ThreeForecastTrackingContainer />
    </PageFrame>
  );
}
